module.exports = __webpack_public_path__ + "assets/6f77d1c97d1c6937d21c4a1034be62b6.js";